export const apiUrls = {
  apiHost: () => {
    return process.env.NEXT_PUBLIC_API_DOMAIN ?? ''
  },
  auth: {
    login: () => `${apiUrls.apiHost()}/api/user/doLogin`,
    logout: () => `${apiUrls.apiHost()}/api/user/invalidateUser`,
  },
  user: {
    changePassword: () => `${apiUrls.apiHost()}/api/user/changePassWord`,
    changeUserEmail: () => `${apiUrls.apiHost()}/api/email/changeUserEmail`,
    sendResetPasswordEmail: () => `${apiUrls.apiHost()}/api/email/checkUser`,
    getResearchArea: () => `${apiUrls.apiHost()}/api/user/getResearchArea`,
    checkAccountExist: () => `${apiUrls.apiHost()}/api/user/checkAccountExist`,
    doRegister: () => `${apiUrls.apiHost()}/api/user/doRegister`,
    doFollow: () => `${apiUrls.apiHost()}/api/user/doFollow`,
  },
  company: {
    getCompanyInfo: () => `${apiUrls.apiHost()}/api/company/getCompanyInfoByID`,
  },
  personal: {
    getPersonInfo: () => `${apiUrls.apiHost()}/api/personal/getPersonInfo`,
    savePersonInfo: () => `${apiUrls.apiHost()}/api/personal/savePersonInfo`,
    getWorkExperience: () => `${apiUrls.apiHost()}/api/personal/getWorkExperience`,
    addWorkExperience: () => `${apiUrls.apiHost()}/api/personal/addWorkExperience`,
    editWorkExperience: () => `${apiUrls.apiHost()}/api/personal/editWorkExperience`,
    deleteWorkExperience: () => `${apiUrls.apiHost()}/api/personal/deleteWorkExperience`,
    getPaperByPersonId: () => `${apiUrls.apiHost()}/api/personal/getPaperByPersonId`,
    getAchievementByPersonId: () => `${apiUrls.apiHost()}/api/personal/getAchievementByPersonId`,
    upAchievement: () => `${apiUrls.apiHost()}/api/personal/upResearchAchievement`,
    updateAchievement: () => `${apiUrls.apiHost()}/api/personal/updateResearchAchievement`,
    deleteAchievement: () => `${apiUrls.apiHost()}/api/personal/deleteResearchAchievement`,
    upPaper: () => `${apiUrls.apiHost()}/api/personal/upPaper`,
    uploadPaper: () => `${apiUrls.apiHost()}/api/personal/uploadPaper`,
    updatePaper: () => `${apiUrls.apiHost()}/api/personal/updatePaper`,
    deletePaper: () => `${apiUrls.apiHost()}/api/personal/deletePaper`,
    getRecruitmentInfoList: () => `${apiUrls.apiHost()}/api/company/getRecruitmentInfoList`,
    getRecruitmentSimilarList: () => `${apiUrls.apiHost()}/api/company/getSimilarRecruitment`,
    getRecruitmentList: () => `${apiUrls.apiHost()}/api/company/getRecruitmentList`,
    getRecruitmentRecentList: () => `${apiUrls.apiHost()}/api/history/getRecentlyView`,
    saveRecruitmentRecent: () => `${apiUrls.apiHost()}/api/history/saveViewedJobHistory`,
    getFollowList: () => `${apiUrls.apiHost()}/api/company/getFollowList`,
    createJobInfo: () => `${apiUrls.apiHost()}/api/personal/addJobInfo`,
    editJobInfo: () => `${apiUrls.apiHost()}/api/personal/modJobInfo`,
  },
  recruitment: {
    addInterview: () => `${apiUrls.apiHost()}/api/interview/addInterview`,
    getFillPercent: () => `${apiUrls.apiHost()}/api/personal/getFillPercent`,
  },
  chat: {
    list: () => `${apiUrls.apiHost()}/api/chat/getChatInfo`,
    archiveList: () => `${apiUrls.apiHost()}/api/chat/getArchivedChatInfo`,
    messages: () => `${apiUrls.apiHost()}/api/chat/getChatMessage`,
    archive: () => `${apiUrls.apiHost()}/api/chat/archive`,
    delete: () => `${apiUrls.apiHost()}/api/chat/deleteChatInfo`,
    count: () => `${apiUrls.apiHost()}/api/chat/getChatCount`,
    sendReminder: () => `${apiUrls.apiHost()}/api/chat/emailMessageReminder`,
    sendRecruit: () => `${apiUrls.apiHost()}/api/chat/saveRecruitMsg`,
    send: () => `${apiUrls.apiHost()}/api/chat/saveRecruitMsg`,
    getChatInfoOfOtherSend: () => `${apiUrls.apiHost()}/api/chat/getChatInfoOfOtherSend`,
    getChatInfoOfSelfSend: () => `${apiUrls.apiHost()}/api/chat/getChatInfoOfSelfSend`,
  },
  file: {
    upload: () => `${apiUrls.apiHost()}/page/file/upload`,
    uploadBase64: () => `${apiUrls.apiHost()}/api/file/uploadBase64Image`,
  },
}
